const STORAGE_KEY = 'swarnakamala-wishlist';

function readWishlist() {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    if (!Array.isArray(value)) return [];

    return value
      .map((item) => (typeof item === 'object' ? item : { id: String(item), handle: '' }))
      .filter((item) => item.id)
      .map((item) => ({ id: String(item.id), handle: String(item.handle || '') }));
  } catch {
    return [];
  }
}

function writeWishlist(wishlist) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
  document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: wishlist }));
}

function updateButton(button, wishlist) {
  const isSaved = wishlist.some((item) => item.id === String(button.dataset.productId));
  const productName =
    button.dataset.productTitle ||
    button.closest('product-card')?.querySelector('.product-card__link')?.getAttribute('aria-label') ||
    'Product';

  button.setAttribute('aria-pressed', String(isSaved));
  button.setAttribute('aria-label', `${isSaved ? 'Remove' : 'Add'} ${productName} ${isSaved ? 'from' : 'to'} wishlist`);
}

function syncWishlistUI() {
  const wishlist = readWishlist();
  let upgraded = false;

  document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
    const savedItem = wishlist.find((item) => item.id === String(button.dataset.productId));
    if (savedItem && !savedItem.handle && button.dataset.productHandle) {
      savedItem.handle = String(button.dataset.productHandle);
      upgraded = true;
    }
  });

  if (upgraded) localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));

  document.querySelectorAll('[data-wishlist-button]').forEach((button) => updateButton(button, wishlist));
  document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
    count.textContent = String(wishlist.length);
    count.hidden = wishlist.length === 0;
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wishlist-button]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const productId = String(button.dataset.productId);
  const wishlist = readWishlist();
  const existingIndex = wishlist.findIndex((item) => item.id === productId);

  if (existingIndex >= 0) {
    wishlist.splice(existingIndex, 1);
  } else {
    wishlist.push({ id: productId, handle: String(button.dataset.productHandle || '') });
  }

  writeWishlist(wishlist);
});

document.addEventListener('DOMContentLoaded', syncWishlistUI);
document.addEventListener('shopify:section:load', syncWishlistUI);
document.addEventListener('wishlist:updated', syncWishlistUI);
